const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  content: {
    display: 'grid',
    gap: '12px',
    width: '100%',
  },
  logoDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
  },
  logo: {
    width: '32px',
    height: '32px',
  },
  title: {
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '150%',
  },
  messageDiv: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '4px',
  },
  message: {
    color: 'var(--mcg-gray, #919EAB)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '150%',
    textAlign: 'center',
  },
  connectSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    padding: '16px 0',
  },
  connectButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 24px',
    backgroundColor: '#015FFB',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#0050D0',
    },
  },
  selectSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  selectLabel: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: '500',
  },
  dropdownWrapper: {
    position: 'relative',
  },
  searchInput: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '8px',
    border: '1px solid #DFE3E8',
    fontFamily: 'Inter',
    fontSize: '14px',
    color: '#002E47',
    backgroundColor: '#F4F6F8',
    outline: 'none',
    boxSizing: 'border-box',
    '&:focus': {
      borderColor: '#015FFB',
    },
    '&::placeholder': {
      color: '#919EAB',
    },
  },
  dropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    maxHeight: '180px',
    overflowY: 'auto',
    backgroundColor: '#fff',
    border: '1px solid #DFE3E8',
    borderRadius: '8px',
    marginTop: '4px',
    zIndex: 10,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  dropdownItem: {
    padding: '8px 12px',
    fontFamily: 'Inter',
    fontSize: '13px',
    color: '#002E47',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F4F6F8',
    },
  },
  dropdownItemActive: {
    backgroundColor: '#EBF2FF',
    fontWeight: '500',
  },
  dropdownEmpty: {
    padding: '12px',
    fontFamily: 'Inter',
    fontSize: '13px',
    color: '#919EAB',
    textAlign: 'center',
  },
  quizSection: {
    paddingTop: '4px',
  },
  quizLabel: {
    fontFamily: 'Inter',
    fontSize: '13px',
    color: '#002E47',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
  },
  quizCountWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '2px',
    border: '1px solid #DFE3E8',
    borderRadius: '6px',
    padding: '0 2px',
    verticalAlign: 'middle',
  },
  quizCountBtn: {
    width: '22px',
    height: '22px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: '600',
    color: '#015FFB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#F4F6F8',
    },
    '&:disabled': {
      color: '#C4CDD5',
      cursor: 'default',
    },
  },
  quizCountValue: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: '500',
    color: '#002E47',
    minWidth: '18px',
    textAlign: 'center',
  },
  buttonDiv: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '4px',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingTitle: {
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: '500',
    color: '#002E47',
    textAlign: 'center',
  },
  loadingSubtitle: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: '400',
    color: '#838D98',
    textAlign: 'center',
    maxWidth: '400px',
  },
})

export default styles
